var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectDashboardIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35828 3.88062C5.28561 3.88062 6.03735 3.12887 6.03735 2.20154C6.03735 1.27421 5.28561 0.522461 4.35828 0.522461C3.43095 0.522461 2.6792 1.27421 2.6792 2.20154C2.6792 3.12887 3.43095 3.88062 4.35828 3.88062Z",
    stroke: "#D42177",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71631 9.47843H1V8.73218C1 7.84154 1.3538 6.98738 1.98358 6.3576C2.61336 5.72783 3.46752 5.37402 4.35815 5.37402C5.24879 5.37402 6.10295 5.72783 6.73273 6.3576C7.3625 6.98738 7.71631 7.84154 7.71631 8.73218V9.47843Z",
    stroke: "#D42177",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDashboardIcon1);
export default __webpack_public_path__ + "static/media/projectDashboardIcon1.4d3d47adf135d29742e7f70c574f7eac.svg";
export { ForwardRef as ReactComponent };